import React, { useState, useEffect } from 'react';

function ModelSelector({ provider, setProvider }) {
  const options = [
    { value: 'google', label: 'Gemini Flash' },
    { value: 'together', label: 'Llama-3.3-70B' },
    { value: 'ollama', label: 'Gemma 3 1b' }
  ];

  // Find label based on initial provider
  const getLabelFromValue = (value) => {
    const found = options.find((opt) => opt.value === value);
    return found ? found.label : 'Choose Model';
  };

  const [selectedLabel, setSelectedLabel] = useState(getLabelFromValue(provider));

  // When provider changes from outside, update label
  useEffect(() => {
    setSelectedLabel(getLabelFromValue(provider));
  }, [provider]);

  const handleSelect = (value, label) => {
    setProvider(value);
    setSelectedLabel(label);
  };

  return (
    <div className="dropdown">
      <button
        className="dropdown-toggle"
        type="button"
        id="modelDropdown"
        data-toggle="dropdown"
        aria-expanded="true"
      >
        {/* {selectedLabel} <span className="caret" /> */}
        <i class="fa fa-angle-down"></i>

      </button>
      <ul className="dropdown-menu" role="menu" aria-labelledby="modelDropdown">
        {options.map((option) => (
          <li
            key={option.value}
            className={provider === option.value ? 'active' : ''}
          >
            <a
              href="#"
              role="menuitem"
              tabIndex="-1"
              onClick={(e) => {
                e.preventDefault();
                handleSelect(option.value, option.label);
              }}
            >
              {option.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ModelSelector;



// WEBPACK FOOTER //
// ./src/components/ai/ModelSelector.js